import * as React from "react";
import { forwardRef } from "react";
const SvgArrowUpdown = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.293 8.293a1 1 0 0 0 1.414 1.414L12 5.414l4.293 4.293a1 1 0 0 0 1.414-1.414l-5-5a1 1 0 0 0-1.414 0zm11.414 7.414a1 1 0 0 0-1.414-1.414L12 18.586l-4.293-4.293a1 1 0 0 0-1.414 1.414l5 5a1 1 0 0 0 1.414 0z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgArrowUpdown);
export default ForwardRef;
